import { jsx as o } from "react/jsx-runtime";
import { TriangleExclamationIcon as e, CircleExclamationIcon as n } from "../../icons/componentIcons.mjs";
const l = ({ status: r }) => r === "warning" ? /* @__PURE__ */ o(e, { color: "orange.500", size: "xl", marginTop: { base: 0.5, md: 1 } }) : r === "error" ? /* @__PURE__ */ o(n, { color: "red.500", size: "xl", marginTop: { base: 0.5, md: 1 } }) : void 0;
export {
  l as ModalHeaderIcon
};
